import EditableCell from "./EditableCell"

interface EditableCellProps<T> {
   label: string
   min: number
   valueKey: keyof T
   isEditing: boolean
   form: T
   setFormState: (form: T) => void
   thresholdKeyTooltip?: { key: string; tooltipMessage: string }
}

function EditableRow<T>({
   label,
   min,
   valueKey,
   isEditing,
   form,
   setFormState,
   thresholdKeyTooltip,
}: EditableCellProps<T>) {
   const value = form[valueKey]
   return (
      <tr>
         <td>{label}</td>
         <td>
            <EditableCell
               isEditing={isEditing}
               min={min}
               name={String(valueKey)}
               onChange={(e) =>
                  setFormState({
                     ...form,
                     [valueKey]:
                        typeof value === "number"
                           ? Number(e.target.value)
                           : e.target.value,
                  })
               }
               error={
                  !!thresholdKeyTooltip && thresholdKeyTooltip.key === valueKey
               }
               type="number"
               value={
                  typeof value === "number" ? value.toString() : String(value)
               }
               content={
                  (!!thresholdKeyTooltip &&
                     thresholdKeyTooltip.tooltipMessage) ||
                  ""
               }
            >
               <>{["string", "number"].includes(typeof value) ? value : null}</>
            </EditableCell>
         </td>
      </tr>
   )
}

export default EditableRow
